import getLocalStorageItem from "@helpers/getLocalStorageItem";
import { noop } from "lodash";
import React from "react";

export type InspectorModes = "simple" | "detailed";

export const inspectorStorageKey = "lingo_inspector_preference";

export type ViewModesState = {
  inspectorMode: InspectorModes;
};

export type ViewModesContextType = {
  inspectorMode: ViewModesState["inspectorMode"];
  setInspectorMode: React.Dispatch<React.SetStateAction<ViewModesState["inspectorMode"]>>;
};

export const initialState: ViewModesState = {
  inspectorMode: getLocalStorageItem<InspectorModes>(inspectorStorageKey, "simple"),
};

export const ViewModeContext = React.createContext<ViewModesContextType>({
  inspectorMode: initialState.inspectorMode,
  setInspectorMode: noop,
});
